import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const likeImporterSelectors =
  importerSelectors('like.importer')

export default likeImporterSelectors
